import React from "react";
import { COMPANY } from "../data";
import { PageHero, useSeo } from "../ui";

/* 개인정보처리방침 — 개발 문의 폼(/contact) · 상담 문의 폼(/for/contact) · 회원에서 수집하는 항목을 다룬다.
   수집 항목이 바뀌면 ui.jsx 의 ContactForm, landing/LandingContact.jsx,
   backend/app/inquiries.py · landing.py(PRIVACY_VERSION) 와 함께 고쳐야 한다. */
const EFFECTIVE_DATE = "2026년 11월 3일";

const SECTIONS = [
  {
    title: "1. 수집하는 개인정보 항목",
    body: [
      "I.META(아이닷메타)는 아래와 같이 개인정보를 수집합니다.",
    ],
    list: [
      "개발 문의 폼 필수 항목 — 이름, 이메일 주소, 문의 유형, 현재 단계, 문의 내용",
      "개발 문의 폼 선택 항목 — 상호·기관명, 연락처, 희망 일정, 예산 범위, 첨부 파일",
      "개발 문의 폼에서 '공동개발(Partnership) 문의' 선택 시 추가 필수 항목 — 연락처, 사업자 형태, 업종, 판매 방법·판로, 정부지원사업 여부(선정 시 지원사업명·개발 가능 예산·협약 종료일)",
      "상담 문의 폼(분야별 안내 페이지) 필수 항목 — 이름, 연락처, 이메일 주소, 아이디어 요약",
      "상담 문의 폼 선택 항목 — 분야, 현재 단계, 희망 진행 방식, 예산 범위, 희망 완료 시점, 예상 판매·양산 수량, 정부지원사업 수행 여부, 제작 과정 영상 공개 가능 여부, 첨부 파일",
      "회원가입 필수 항목 — 이메일 주소, 비밀번호, 이름",
      "회원가입 선택 항목 — 연락처, 회사·기관명, 마케팅 수신 동의 여부",
      "자동 수집 항목 — 접속 IP 주소, 브라우저 정보 (스팸 방지, 중복 접수 확인, 로그인 세션 관리 목적)",
      "상담 문의 시 자동 수집 항목 — 유입 경로(방문 전 사이트 주소, 홍보 링크의 채널·캠페인 정보) (홍보 채널별 효과 확인 목적)",
    ],
  },
  {
    title: "1-1. 비밀번호의 처리",
    body: [
      "회원의 비밀번호는 원문을 저장하지 않습니다. 복원이 불가능한 해시 값으로만 보관하므로, 회사도 회원의 비밀번호를 알 수 없습니다. 비밀번호를 잊으신 경우 재설정 절차를 이용하셔야 합니다.",
    ],
  },
  {
    title: "2. 개인정보의 수집·이용 목적",
    list: [
      "문의하신 내용에 대한 확인과 회신",
      "개발 의뢰 검토, 견적 산출 및 상담 진행",
      "공동개발(Partnership) 문의 검토(공동개발 심사) 및 결과 회신",
      "접수 확인 메일 발송",
      "회원 식별, 로그인 및 회원 전용 서비스 제공",
      "제품 구매 및 배송, 고객 응대",
      "마케팅 수신에 동의하신 경우 신제품·자료 소식 안내",
      "스팸·악용 방지 및 서비스 운영 기록 관리",
    ],
    body: ["수집한 개인정보는 위 목적 외의 용도로 이용하지 않습니다."],
  },
  {
    title: "3. 보유 및 이용 기간",
    list: [
      "개발 문의 정보 · 상담 문의 정보 — 접수일로부터 3년간 보관 후 파기",
      "회원 정보 — 탈퇴 시 즉시 파기 (아래 법정 보존 항목 제외)",
      "계약·결제 기록 — 전자상거래법에 따라 5년간 보관",
      "소비자 불만·분쟁 처리 기록 — 전자상거래법에 따라 3년간 보관",
      "첨부 파일 — 문의 정보와 동일한 기간 보관 후 파기",
    ],
    body: [
      "보유 기간이 지나거나 이용 목적이 달성된 개인정보는 지체 없이 파기합니다. 전자적 파일은 복구할 수 없는 방법으로 삭제합니다.",
    ],
  },
  {
    title: "4. 개인정보의 제3자 제공",
    body: [
      "I.META는 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 따라 수사기관 등이 적법한 절차로 요구하는 경우에는 예외로 합니다.",
    ],
  },
  {
    title: "5. 개인정보 처리의 위탁",
    body: [
      "문의 접수 확인 및 회신 메일 발송을 위해 외부 메일 발송 서비스(Google LLC)를 이용합니다. 위탁 범위는 메일 전송에 필요한 최소한의 정보(수신자 이메일 주소, 메일 본문)에 한정됩니다.",
    ],
  },
  {
    title: "6. 이용자의 권리",
    body: [
      "이용자는 언제든지 본인의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요구할 수 있습니다. 아래 연락처로 요청하시면 지체 없이 처리하고 그 결과를 알려드립니다.",
    ],
  },
  {
    title: "7. 개인정보의 안전성 확보 조치",
    list: [
      "문의 정보와 회원 정보는 접근이 제한된 서버에 저장하며, 관리자 인증을 거친 경우에만 열람할 수 있습니다.",
      "비밀번호는 복원 불가능한 해시로만 저장하고, 로그인 세션 정보 역시 원문이 아닌 해시 형태로 보관합니다.",
      "로그인 세션은 자바스크립트가 접근할 수 없는 쿠키로만 주고받아 탈취 위험을 낮춥니다.",
      "홈페이지 전 구간에 HTTPS 를 적용해 전송 구간을 암호화합니다.",
      "첨부 파일은 허용된 형식만 받으며 공개 경로로 노출하지 않습니다.",
    ],
  },
  {
    title: "8. 개인정보 보호책임자",
    rows: [
      ["책임자", `${COMPANY.ceo} (${COMPANY.name} 대표)`],
      ["이메일", COMPANY.email],
      ["전화", COMPANY.phone],
    ],
    body: [
      "개인정보 처리와 관련한 문의, 불만, 피해 구제는 위 연락처로 접수해 주시기 바랍니다.",
    ],
  },
  {
    title: "9. 권익침해 구제 방법",
    body: [
      "개인정보 침해로 인한 상담·신고가 필요하신 경우 아래 기관에 문의하실 수 있습니다.",
    ],
    list: [
      "개인정보 침해신고센터 — privacy.kisa.or.kr / 국번 없이 118",
      "개인정보 분쟁조정위원회 — kopico.go.kr / 1833-6972",
      "대검찰청 사이버수사과 — spo.go.kr / 국번 없이 1301",
      "경찰청 사이버수사국 — ecrm.police.go.kr / 국번 없이 182",
    ],
  },
  {
    title: "10. 방침의 변경",
    body: [
      "이 개인정보처리방침의 내용이 변경되는 경우, 변경 사항을 홈페이지에 공지합니다.",
    ],
  },
];

export default function Privacy() {
  useSeo({
    title: "개인정보처리방침 | I.META 아이닷메타",
    description:
      "아이닷메타(I.META) 홈페이지 문의 폼을 통해 수집하는 개인정보의 항목, 이용 목적, 보유 기간, 이용자의 권리를 안내합니다.",
    path: "/privacy",
  });

  return (
    <>
      <PageHero
        kicker="PRIVACY"
        title="개인정보처리방침"
        desc={`${COMPANY.name}(${COMPANY.nameKo})는 이용자의 개인정보를 소중히 다루며, 개인정보 보호법 등 관련 법령을 준수합니다.`}
      />

      <section className="section section--tight">
        <article className="legal">
          <p className="legal__date">시행일: {EFFECTIVE_DATE}</p>

          {SECTIONS.map((sec) => (
            <section key={sec.title} className="legal__section">
              <h2 className="legal__title">{sec.title}</h2>

              {sec.body && sec.body.map((t) => <p key={t} className="legal__p">{t}</p>)}

              {sec.list && (
                <ul className="legal__list">
                  {sec.list.map((t) => <li key={t}>{t}</li>)}
                </ul>
              )}

              {sec.rows && (
                <div className="legal__rows">
                  {sec.rows.map(([k, v]) => (
                    <div key={k} className="about__meta-row">
                      <span>{k}</span><strong>{v}</strong>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </article>
      </section>
    </>
  );
}
